import React, { Fragment } from 'react';

import { IconsEnum } from '../../../../../../../assets/icons/types';
import { FetchOperationsCacheKeys } from '../../../../../operationsTypes';
import { UserID } from '../../../../../../users/usersTypes';
import { TeamNanoID } from '../../../../../../teams/teamsTypes';

import { CompanyOperationsCompactTableRowDropdownContentOperation } from './CompanyOperationsCompactTableRowDropdownContent.types';

import {
  UpdateOperationModalButton,
  UpdateOperationModalButtonAccess
} from '../../../../../components/modalButtons/UpdateOperationModalButton';

import { operationsKeys } from '../../../../../../../locales/keys';

interface CompanyOperationsCompactTableRowDropdownContentProps {
  operation: CompanyOperationsCompactTableRowDropdownContentOperation;
  clientsIds?: UserID[];
  teamNanoId?: TeamNanoID;
  updateButtonAccess: UpdateOperationModalButtonAccess;
  cacheKeys?: FetchOperationsCacheKeys;
  withUpdateButton?: boolean;
}

function CompanyOperationsCompactTableRowDropdownContent({
  operation,
  clientsIds,
  teamNanoId,
  updateButtonAccess,
  cacheKeys,
  withUpdateButton
}: CompanyOperationsCompactTableRowDropdownContentProps) {
  const userSelectInitialFilters = clientsIds
    ? { id: { in: clientsIds } }
    : null;
  return (
    <Fragment>
      {withUpdateButton ? (
        <UpdateOperationModalButton
          teamNanoId={teamNanoId}
          operation={operation}
          cacheKeys={cacheKeys}
          className="flex text-left dark:hover:bg-gray-800 hover:bg-gray-100 px-4 py-2 text-sm w-full whitespace-nowrap"
          iconClassName="h-5 w-5 mr-2"
          i18nText={operationsKeys.updateRecord}
          icon={IconsEnum.PENCIL}
          withToastOnSuccess
          access={updateButtonAccess}
          userSelectInitialFilters={userSelectInitialFilters}
        />
      ) : null}
    </Fragment>
  );
}

export default CompanyOperationsCompactTableRowDropdownContent;
